export default __webpack_public_path__ + "static/cb-myworld-faded.url-636c736652534175f51466e831b248f0.svg";